import * as miljokontrollerActions from "../actions/miljokontrollerActions";

const INITIAL_STATE = [];

export default function miljokontrollKommentarerReducer(
  state = INITIAL_STATE,
  action,
) {
  switch (action.type) {
    case miljokontrollerActions.GET_MILJOKONTROLL_KOMMENTARER_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
